(function () {
  'use strict';

  function normalizeNumber(text) {
    var value = parseInt(String(text || '').replace(/[^0-9]/g, ''), 10);
    return Number.isFinite(value) ? value : null;
  }

  function enhanceAllProductsPagination(root) {
    var paginations = (root || document).querySelectorAll('.tl-all-pagination');

    Array.prototype.forEach.call(paginations, function (pagination) {
      if (pagination.querySelector('.tl-all-pagination__status')) return;

      var currentNode = pagination.querySelector('.is-current, [aria-current="page"]');
      var currentPage = normalizeNumber(currentNode && currentNode.textContent) || 1;
      var totalPage = currentPage;

      Array.prototype.forEach.call(pagination.querySelectorAll('a, span'), function (node) {
        var num = normalizeNumber(node.textContent);
        if (num && num > totalPage) totalPage = num;
      });

      if (!currentNode) {
        Array.prototype.some.call(pagination.querySelectorAll('span'), function (node) {
          var num = normalizeNumber(node.textContent);
          if (num && !node.classList.contains('is-disabled')) {
            node.classList.add('is-current');
            node.setAttribute('aria-current', 'page');
            currentPage = num;
            return true;
          }
          return false;
        });
      } else {
        currentNode.setAttribute('aria-current', 'page');
      }

      Array.prototype.forEach.call(pagination.querySelectorAll('span'), function (node) {
        var text = node.textContent.trim();
        if (text === '…' || text === '...') node.classList.add('tl-all-pagination__ellipsis');
        if (node.classList.contains('is-disabled')) node.setAttribute('aria-disabled', 'true');
      });

      var status = document.createElement('p');
      status.className = 'tl-all-pagination__status treedix-category-pagination__status';
      status.textContent = 'Page ' + currentPage + ' of ' + totalPage;
      pagination.insertBefore(status, pagination.firstChild);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { enhanceAllProductsPagination(document); });
  } else {
    enhanceAllProductsPagination(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    enhanceAllProductsPagination(event.target || document);
  });
})();
